import moment from 'moment';

export const VueFormatDate = {
  install: (Vue: any, options?: any): void => {
    Vue.filter(
      'formatDate',
      (date: string): string => {
        if (date) {
          return moment(date).format('DD/MM/YYYY HH:mm');
        } else {
          return '';
        }
      },
    );
  },
};
